// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_26-3";
export var dialog = "_26-0";
export var divClassnameSwatch = "_26-8";
export var flexSwatch = "_26-4";
export var header = "_26-1";
export var styleAttributeSwatch = "_26-7";
export var swatch = "_26-2";
export var textHeaderSwatch = "_26-5";
export var webSwatch = "_26-6";